import React from "react";
import { Link } from "react-router-dom";
import { edit_icon } from "../../../icons/edit";
import { delete_icon } from "../../../icons/trash";
import empty_box from "../../../images/empty_box.png";
import { useAuth } from "../../../store/authProvider";
import { useState } from "react";
import { useQuery, } from "@tanstack/react-query";
import Client from "../../../utils/client";
import {
  getMe,
  getOfferFavorites,
  getStates,
} from "../../../api";
import DeleteModal from "./deleteModal";
import ContactModal from "../../../components/contact_modal";
import ConvertToArabicNumbers from "../../../utils/convert_numbers";
import { cities_data, markets_data } from "../../../data";
import ShowModal from "../../../components/show_modal";
import Skelton from "../../../icons/skelton";

function CropsInputs() {
  const { isAuth } = useAuth();
  const [showContactModal, setShowContactModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);

  const {
    data: myOffers,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["my_offers"],
    queryFn: () => getMe(),
    initialData: [],
  });

  const [offer, setOffer] = useState();
  const getOffer = async (id) => {
    const response = await Client.get(`/offer/${id}`).then((res) => res.data);
    setOffer(response);
    setShowModal(true);
  };


  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const { data: offersFavorites , isFetching:offersFetching } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => getOfferFavorites(),
    initialData: [],
  });

 

  const [item, setItem] = useState();


  if (offersFetching) {
    return (
      <div
        dir="rtl"
        className="my-16 grid grid-cols-1 gap-4 px-0 lg:grid-cols-5 lg:mr-8"
      >
        {[...Array(5).keys()].map((e, i) => (
          <Skelton key={i} />
          
        ))}
      </div>
    );
  }
  return (
    <div className="my-10 px-5 lg:px-7">
      <h1 className="lg:text-end font-bold text-end text-[24px] my-10">
        المحاصيل
      </h1>
      {showContactModal && (
        <ContactModal offer={offer} setShowContactModal={setShowContactModal} />
      )}
      {detailsModal && (
        <DeleteModal
          setShowDetails={setDetailsModal}
          item={item}
          refetch={refetch}
        />
      )}
      {showModal && (
        <ShowModal
          offer={offer}
          cities_data={cities_data}
          markets_data={markets_data}
          setShowContactModal={setShowContactModal}
          setShowModal={setShowModal}
          states={states}
          favoriteOffers={offersFavorites}
          type={"متوفر"}
        />
      )}
      {myOffers.offers?.filter((e) => e.status !== "sold").length === 0 ||
      myOffers.offers?.length === 0 ? (
        <div className="flex flex-col h-72 -span-2 mt-10 justify-center items-center text-center lg:col-span-5">
          <div>
            <img src={empty_box} alt=""></img>
          </div>
          <div className="font-bold mt-3">لا توجد مدخلات</div>
          <div className="h-10"></div>
        </div>
      ) : (
        <div className="flex flex-wrap gap-3 flex-row-reverse">
          {myOffers.offers
            ?.filter((e) => e.status !== "sold")
            .map((item) => (
              <div
                className=" w-full lg:w-[13rem] lg:min-w-[13rem] "
                key={item.id}
              >
                <div
                  className="relative  flex flex-row-reverse lg:flex-col items-center justify-evenly overflow-hidden w-full bg-white border-2 border-primary rounded-2xl  h-[8rem] lg:w-auto lg:h-72 min-w-full lg:text-2xl"
                  key={item.id}
                  onClick={() => getOffer(item.id)}
                >
                  <img
                    src={item.subCategory.image}
                    className="  lg:h-2/4  max-w-[108px]  lg:max-w-full mt-2 "
                    alt=""
                  />
                  <div className="flex w-[160px] gap-2 lg:gap-1 lg:w-auto flex-col text-right  lg:mx-auto lg:font-normal">
                    <div
                      className="flex lg:justify-center items-center"
                      dir="rtl"
                    >
                      {/* {item.type === "buy" && <div className="px-2">مطلوب</div>}  */}
                      <div className="font-bold text-lg my-1">
                        {item.subCategory.name}
                      </div>
                    </div>
                    <div
                      className="lg:text-lg text-sm font-bold lg:font-normal mb-0.5 text-right lg:text-center"
                      dir="rtl"
                    >{`${ConvertToArabicNumbers(item.quantity)} ${
                      item._unit.name
                    }`}</div>
                    <div className=" mb-1 text-sm font-bold lg:font-normal lg:text-center">
                      {item._state.name}
                    </div>
                  </div>
                  <div className="flex lg:flex-row flex-row items-center justify-between gap-3  align-baseline">
                    <div className="flex items-center flex-row mb-2">
                      <div className=" hidden lg:block text-sm text-gray-400">
                        قبل{" "}
                        {Math.ceil(
                          (new Date().getTime() -
                            new Date(item.created_at).getTime()) /
                            86400000
                        )}{" "}
                        يوم
                      </div>
                      <div className="lg:absolute lg:inset-3 flex flex-col gap-6 lg:gap-52">
                        {isAuth &&
                          item.owner === localStorage.getItem("user_id") && (
                            <Link to={`/editform/${item.id}`}>
                              <div className=" font-bold">{edit_icon}</div>
                            </Link>
                          )}
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setItem(item);
                            setDetailsModal(true);
                          }}
                          className="lg:ml-auto cursor-pointer"
                        >
                          {delete_icon}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default CropsInputs;
